import { gql } from 'apollo-boost'

export const TURN_OVER = gql`
  query userTurnOver($data: userTurnOver) {
    userTurnOver(data: $data)
  }
`
